import axios from 'axios';

const sendVerificationCode = ({ id, taxReturnId, companyId }) => {
  return axios.post(
    `/tax_returns/${taxReturnId}/tax_return_identity_verifications/${id}/send_verification_code`,
    {
      company_id: companyId,
    },
  );
};

const verifyCode = ({ id, taxReturnId, companyId, verificationCode }) => {
  return axios.post(
    `/tax_returns/${taxReturnId}/tax_return_identity_verifications/${id}/verify_code`,
    {
      company_id: companyId,
      verification_code: verificationCode,
    },
  );
};

export default {
  sendVerificationCode,
  verifyCode,
};
